import { ParameterError } from '../../types/errors';
import { getSourceQueryResultReferences, QuerySourceType, } from '../../types/querySources';
import { stableJson } from '../../utils/stableJson';
export const isAiComposerChartArtifactConfig = (config) => typeof config === 'object' &&
    config !== null &&
    'source' in config &&
    config.source === 'composer' &&
    'schemaVersion' in config &&
    config.schemaVersion === 1 &&
    'queries' in config &&
    Array.isArray(config.queries) &&
    'terminalNodeId' in config &&
    typeof config.terminalNodeId === 'string';
// The full definition, with array references written in map form.
const nodeDefinition = (node) => stableJson(node.sourceType === QuerySourceType.DUCKDB ||
    node.sourceType === QuerySourceType.PYTHON
    ? { ...node, references: getSourceQueryResultReferences(node) }
    : node);
const describeNodes = (nodes) => nodes.length === 0
    ? 'There are no nodes from earlier versions in this thread.'
    : `Nodes from earlier versions: ${nodes
        .map((node) => `${node.nodeId} ("${node.title ?? node.nodeId}")`)
        .join(', ')}.`;
const hasNodeId = (node) => !!node.nodeId;
export const buildComposerArtifactPipeline = ({ queries, earlierPipelines, }) => {
    const threadNodes = new Map();
    earlierPipelines.forEach((pipeline) => pipeline.queries.forEach((node) => {
        if (node.nodeId)
            threadNodes.set(node.nodeId, node);
    }));
    const submittedNodes = new Map(queries.flatMap((node) => (node.nodeId ? [[node.nodeId, node]] : [])));
    submittedNodes.forEach((node, nodeId) => {
        const earlier = threadNodes.get(nodeId);
        if (earlier && nodeDefinition(earlier) !== nodeDefinition(node)) {
            throw new ParameterError(`Node id "${nodeId}" already names a different node in this thread ("${earlier.title ?? nodeId}"). To reuse it, read "${nodeId}" without resubmitting it; to define a new node, give it a different node id.`);
        }
    });
    queries.forEach((node) => Object.values(getSourceQueryResultReferences(node)).forEach((reference) => {
        if (!submittedNodes.has(reference) &&
            !threadNodes.has(reference)) {
            throw new ParameterError(`Node "${node.nodeId}" reads "${reference}", which is not a node of this submission or of an earlier version in this thread. ${describeNodes([...threadNodes.values()])}`);
        }
    }));
    const emitted = new Set();
    const visiting = new Set();
    const pipeline = [];
    const visit = (node) => {
        if (!hasNodeId(node))
            return;
        const { nodeId } = node;
        if (emitted.has(nodeId) || visiting.has(nodeId))
            return;
        visiting.add(nodeId);
        Object.values(getSourceQueryResultReferences(node)).forEach((reference) => {
            const read = submittedNodes.get(reference) ?? threadNodes.get(reference);
            if (read)
                visit(read);
        });
        visiting.delete(nodeId);
        emitted.add(nodeId);
        pipeline.push(node);
    };
    queries.forEach(visit);
    return pipeline;
};
//# sourceMappingURL=composerArtifact.js.map